import React, { useContext, useEffect, useState } from "react"
import Drawer from "@material-ui/core/Drawer"
import { makeStyles } from "@material-ui/core/styles"
import { IconButton, Typography, Hidden } from "@material-ui/core"
import { FormattedMessage, injectIntl } from "react-intl"
import { CartList, EmptyCart, CartContext, CartSubtotal } from ".."
import CloseIcon from "../../images/close.svg"
import expandLess from "../../images/expand_less.svg"
import expandMore from "../../images/expand_more.svg"
import withWidth from "@material-ui/core/withWidth"
import { Redirect } from "@reach/router"
import { Loader } from "../"
import { Link } from "gatsby"

const useStyles = makeStyles(theme => ({
  root: {
    width: "40vw",
  },
  cartContainer: {
    width: "40vw",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    position: "relative",
    [theme.breakpoints.up("lg")]: {
      margin: theme.spacing(0, 6),
      justifyContent: "space-between",
    },
    [theme.breakpoints.down("md")]: {
      width: "100vw",
    },
  },

  nonModalCartContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    position: "relative",
    [theme.breakpoints.up("lg")]: {
      margin: theme.spacing(0, 6),
      justifyContent: "space-between",
    },
    [theme.breakpoints.down("md")]: {
      width: "100vw",
    },
  },
  colorWhite: {
    backgroundColor: "#fff",
  },
  colorGrey: {
    backgroundColor: "#f5f5f5",
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: theme.palette.black.supportLight,
    padding: theme.spacing(4, 0),
  },
  listContainer: {
    paddingTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    [theme.breakpoints.up("lg")]: {
      paddingBottom: theme.spacing(9),
    },
  },
  listContainerNoModal: {
    paddingTop: theme.spacing(7.25),
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  },
  closeButton: {
    position: "absolute",
    right: 0,
    [theme.breakpoints.down("md")]: {
      right: theme.spacing(2),
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  closeImage: {
    height: "24px",
    width: "24px",
    color: "#212221",
  },
  summaryContainer: {
    width: "100vw",
    position: "relative",
    top: "0",
    height: theme.spacing(8),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(0, 2),
    backgroundColor: "#F5F5F5",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.16)",
  },
  shoppingBagImage: {
    height: theme.spacing(4),
    width: theme.spacing(4),
    marginRight: theme.spacing(1),
  },
  chevron: {
    height: theme.spacing(3),
    width: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  wrapper: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  logoImage: {
    position: "relative",
    width: "48px",
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    left: "50%",
    transform: "translate(-50%)",
  },
  cartCount: {
    alignItems: "center",
    backgroundColor: theme.palette.green.main,
    borderRadius: "50%",
    color: theme.palette.green.contrastText,
    display: "flex",
    height: theme.spacing(3.5),
    justifyContent: "center",
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(0.5),
    width: theme.spacing(3.5),
  },
  fixedMobileHeader: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "#fff",
    },
  },
  hidden: {
    visibility: "hidden",
  },
  outOfService: {
    padding: theme.spacing(0, 1, 0, 1),
    color: "red",
    [theme.breakpoints.down("md")]: {
      margin: theme.spacing(0, 2, 0, 2),
    },
    textAlign: "justify",

    wordWrap: "break-word",
  },
}))

const CartModal = injectIntl(props => {
  const classes = useStyles()
  const Logo = props.header.mainLogo.file.url
  const ShoppingBag = props.header.shoppingCartLogo.file.url
  const { count, getLoaderActive } = useContext(CartContext)
  const redirectPath = "/" + props.langKey + "?transition=true"
  const redirectTo = "/" + props.langKey
  const [openLoader, setOpenLoader] = useState(getLoaderActive())

  let checkLoaderStatus = () => {
    if (getLoaderActive() != openLoader) {
      setOpenLoader(getLoaderActive())
    }

    if (getLoaderActive() == false) {
      clearInterval(checkLoaderInterval)
    }
  }

  const hideLoader = function() {
    setOpenLoader(false)
  }
  let checkLoaderInterval
  useEffect(() => {
    checkLoaderInterval = setInterval(checkLoaderStatus, 1000)
  })

  return (
    <div className={!props.isModal ? classes.root : null}>
      {!props.isModal && count !== null && count < 1 && (
        <Redirect noThrow to={redirectPath} />
      )}
      {props.isCheckout ? (
        <div anchor="right" classes={classes.colorGrey}>
          {openLoader && <Loader />}
          <div
            className={
              props.isModal
                ? classes.cartContainer
                : classes.nonModalCartContainer
            }
          >
            <Hidden mdDown>
              {count !== null &&
                (count > 0 && count !== null ? (
                  <div className={classes.listContainerNoModal}>
                    <CartList hideLoader={hideLoader} langKey={props.langKey} />
                    <CartSubtotal
                      isCheckout={props.isCheckout}
                      isModal={props.isModal}
                      onClose={props.onClose}
                    />
                  </div>
                ) : (
                  props.isModal && <EmptyCart redirectTo={redirectTo} />
                ))}
            </Hidden>
            <Hidden lgUp>
              <div className={classes.fixedMobileHeader}>
                <div>
                  <Link to="/">
                    <img
                      src={Logo}
                      className={classes.logoImage}
                      data-cy="header-logo"
                      alt="Logo"
                    />
                  </Link>
                </div>

                <div
                  className={classes.summaryContainer}
                  onClick={() => props.setShowCart(!props.showCart)}
                >
                  <div className={classes.wrapper}>
                    <img
                      src={ShoppingBag}
                      className={classes.shoppingBagImage}
                      alt="Shopping Bag"
                    />
                    <Typography variant={"body2"} component={"h1"}>
                      <FormattedMessage id="ViewOrderSummary" />
                    </Typography>
                    {props.showCart ? (
                      <img
                        src={expandLess}
                        className={classes.chevron}
                        alt={"Show or hide shopping cart"}
                      />
                    ) : (
                      <img
                        src={expandMore}
                        className={classes.chevron}
                        alt={"Show or hide shopping cart"}
                      />
                    )}
                  </div>
                </div>
                {props.showCart && (
                  <div>
                    {count !== null &&
                      (count > 0 && count !== null ? (
                        <div className={classes.listContainer}>
                          <CartList
                            hideLoader={hideLoader}
                            langKey={props.langKey}
                          />
                          <CartSubtotal
                            isCheckout={props.isCheckout}
                            isModal={props.isModal}
                            onClose={props.onClose}
                          />
                        </div>
                      ) : (
                        props.isModal && <EmptyCart redirectTo={redirectTo} />
                      ))}
                  </div>
                )}
              </div>
            </Hidden>
          </div>
        </div>
      ) : (
        <Drawer
          anchor="right"
          classes={{
            paper: props.isCheckout ? classes.colorGrey : classes.colorWhite,
          }}
          onClose={props.onClose}
          open={props.open}
          variant={props.isModal ? "temporary" : "permanent"}
        >
          {openLoader && <Loader isFull={true} />}
          {openLoader && (
            <div className={classes.hidden}>
              <div
                className={
                  props.isModal
                    ? classes.cartContainer
                    : classes.nonModalCartContainer
                }
              >
                <div className={classes.titleContainer}>
                  <Typography variant={"h4"} component={"h1"}>
                    <FormattedMessage id="yourCart" />
                  </Typography>
                  {count > 0 && (
                    <Typography
                      data-cy="cart-count"
                      variant={"button"}
                      classes={{ root: classes.cartCount }}
                    >
                      {count}
                    </Typography>
                  )}
                  <IconButton
                    className={classes.closeButton}
                    onClick={() => props.onClose()}
                  >
                    <img
                      className={classes.closeImage}
                      src={CloseIcon}
                      alt={"Close Cart"}
                    />
                  </IconButton>
                </div>
                {count !== null &&
                  (count > 0 ? (
                    <div className={classes.listContainer}>
                      <CartList
                        hideLoader={hideLoader}
                        langKey={props.langKey}
                      />
                      <CartSubtotal
                        isModal={props.isModal}
                        onClose={props.onClose}
                      />
                    </div>
                  ) : (
                    props.isModal && <EmptyCart redirectTo={redirectTo} />
                  ))}
              </div>
            </div>
          )}
          {!openLoader && (
            <div
              className={
                props.isModal
                  ? classes.cartContainer
                  : classes.nonModalCartContainer
              }
            >
              <div className={classes.titleContainer}>
                <Typography variant={"h4"} component={"h1"}>
                  <FormattedMessage id="yourCart" />
                </Typography>
                {count > 0 && (
                  <Typography
                    data-cy="cart-count"
                    variant={"button"}
                    classes={{ root: classes.cartCount }}
                  >
                    {count}
                  </Typography>
                )}
                <IconButton
                  className={classes.closeButton}
                  onClick={() => props.onClose()}
                >
                  <img
                    className={classes.closeImage}
                    src={CloseIcon}
                    alt={"Close Cart"}
                  />
                </IconButton>
              </div>
              ​
              {count !== null &&
                (count > 0 ? (
                  <>
                    {/* <Typography variant={"h6"} className={classes.outOfService}>
                      <FormattedMessage id="outOfServiceTitle" />
                    </Typography>
                    <Typography variant={"h6"} className={classes.outOfService}>
                      <FormattedMessage id="outOfServiceContent" />
                    </Typography> */}
                    <div className={classes.listContainer}>
                      <CartList
                        hideLoader={hideLoader}
                        langKey={props.langKey}
                      />
                      <CartSubtotal
                        isModal={props.isModal}
                        onClose={props.onClose}
                      />
                    </div>
                  </>
                ) : (
                  props.isModal && <EmptyCart redirectTo={redirectTo} />
                ))}
            </div>
          )}
        </Drawer>
      )}
    </div>
  )
})

export default withWidth()(CartModal)
